import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { onAuthStateChanged } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { auth, db } from '../firebase';
import Logo from '../components/Logo';
import './SubscriptionSuccess.css';

const SubscriptionSuccess = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [subscription, setSubscription] = useState(null);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
      if (currentUser) {
        fetchUserSubscription(currentUser.uid);
      } else {
        setLoading(false);
      }
    });

    return () => unsubscribe();
  }, []);

  const fetchUserSubscription = async (userId) => {
    try {
      const userDoc = await getDoc(doc(db, 'users', userId));
      if (userDoc.exists()) {
        const userData = userDoc.data();
        if (userData.subscription_status && userData.subscription_type) {
          setSubscription({
            status: userData.subscription_status,
            type: userData.subscription_type,
            planId: userData.subscription_plan_id,
            priceId: userData.subscription_price_id,
            quantity: userData.subscription_quantity,
            currentPeriodEnd: userData.subscription_current_period_end,
            currentPeriodStart: userData.subscription_current_period_start,
            subscriptionId: userData.subscription_id
          });
        }
      }
    } catch (error) {
      console.error('Error fetching user subscription:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleGoToSubscription = () => {
    navigate('/subscription');
  };

  const handleGoToDashboard = () => {
    navigate('/profile');
  };

  if (!user) {
    return (
      <div className="subscription-success">
        <div className="container">
          <div className="message-card">
            <div className="icon error">⚠️</div>
            <h1>Autenticação Necessária</h1>
            <p>Por favor, faça login para ver os detalhes da sua assinatura.</p>
            <button onClick={() => navigate('/login')} className="action-btn">
              Ir para Login
            </button>
          </div>
        </div>
      </div>
    );
  }

  if (loading) {
    return (
      <div className="subscription-success">
        <div className="container">
          <div className="loading">
            <div className="spinner"></div>
            <p>Carregando detalhes da sua assinatura...</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="subscription-success">
      <div className="container">
        <div className="message-card">
          <div className="icon success">✅</div>
          <h1>Assinatura Realizada com Sucesso!</h1>
          <p>Obrigado por assinar! Sua assinatura foi ativada.</p>

          {subscription && (
            <div className="subscription-details">
              <h3>Detalhes da Assinatura</h3>
              <div className="detail-grid">
                <div className="detail-item">
                  <label>Status:</label>
                  <span className={`status ${subscription.status}`}>
                    {subscription.status.charAt(0).toUpperCase() + subscription.status.slice(1)}
                  </span>
                </div>
                <div className="detail-item">
                  <label>Tipo:</label>
                  <span>{subscription.type}</span>
                </div>
                <div className="detail-item">
                  <label>Dispositivos:</label>
                  <span>{subscription.quantity} dispositivo{subscription.quantity > 1 ? 's' : ''}</span>
                </div>
                {subscription.currentPeriodEnd && (
                  <div className="detail-item">
                    <label>Próxima cobrança:</label>
                    <span>{subscription.currentPeriodEnd.toDate().toLocaleDateString('pt-BR')}</span>
                  </div>
                )}
              </div>
            </div>
          )}

          <div className="action-buttons">
            <button onClick={handleGoToSubscription} className="action-btn primary">
              Gerenciar Assinatura
            </button>
            <button onClick={handleGoToDashboard} className="action-btn secondary">
              Ir para Dashboard
            </button>
          </div>

          <div className="next-steps">
            <h4>Próximos Passos</h4>
            <ul>
              <li>Sua assinatura está ativa e pronta para uso</li>
              <li>Você pode gerenciar suas configurações de assinatura a qualquer momento</li>
              <li>Adicione seus dispositivos para começar o rastreamento</li>
              <li>Entre em contato com o suporte se precisar de ajuda</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionSuccess;